module.exports = __webpack_public_path__ + "static/media/imagemColetoresHospital.8da83966.png";